export const ModalType = {
  CANCEL: 'CANCEL',
  DETAIL: 'DETAIL',
}
